import { action, computed, observable, makeAutoObservable } from 'mobx';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { SdkStaff } from 'src/AppState/sdk/staff';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';

export class CompetitionEventNameState {
    @observable private eventNameValueInner: string | null = null;
    @observable public isEditMode: boolean = false;

    constructor(
        private readonly eventIdInner: () => EventId,
        private readonly sdkStaff: SdkStaff
    ) {
        makeAutoObservable(this);
    }

    @computed get eventId(): EventId {
        return this.eventIdInner();
    }

    @computed get eventModel(): EventModel | null {
        return this.eventId.getEventModel();
    }

    @computed get eventName(): string {
        return this.eventModel?.name ?? '';
    }

    @computed get competitionName(): string {
        if (this.eventModel !== null) {
            return this.sdkStaff.models.getCompetitionModel(this.eventModel.competition)?.name ?? '';
        }

        return '';
    }

    @computed get eventNameValue(): string {
        if (this.eventNameValueInner !== null) {
            return this.eventNameValueInner;
        } else {
            return this.eventModel?.name ?? '';
        }
    }

    @action setEeventNameValue = (e: React.ChangeEvent<HTMLInputElement>): void => {
        this.eventNameValueInner = e.currentTarget.value;
    };

    @action setIsEditMode = (): void => {
        this.isEditMode = !this.isEditMode;
    };

    @action onSaveEventName = async (): Promise<void> => {
        await this.sdkStaff.updateEvent({
            event_id: this.eventId.toOldId(),
            requestBody: { name: this.eventNameValue },
        });
        this.isEditMode = false;
    };
}
